/**
 * @packageDocumentation
 * @module      EmcSystem.ts
 * @description Encapsulates the EMC data per system and also the logic of packet tracking per system.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import EmcConsts from "./EmcConsts";
import EmcPacketCollection from "./EmcPacketCollection";
import ConsoleLogger from "../ConsoleLogger";
export default class EmcSystem {
    constructor(systemId) {
        this.emcSignals = {
            ScreenDefocussed: false,
            IdleMonitor: false,
            TestDisable: true,
            UserInput: false,
            FullSystem: false,
            ArmLockUnlock: false,
            DriveJog: false,
            EmcReset: false,
            EmcMode: false,
            RotJog1: true,
            RotJog2: true,
            RotJog3: true,
            RotJog4: true
        };
        this.systemId = systemId;
        this.lastPacketId = 0;
        this.pollAttempt = 0;
        this.packets = new Set();
        this.messages = "";
    }
    ;
    addPacket(packetId) {
        if (false == this.packets.has(packetId)) {
            this.packets.add(packetId);
        }
    }
    removePacket(packetId) {
        if (true == this.packets.has(packetId)) {
            this.packets.delete(packetId);
            EmcPacketCollection.removePacket(this.systemId, packetId);
        }
    }
    getCurrentPacket() {
        let emcPacket;
        let currentPacketId = this.lastPacketId + 1;
        let packetFound = false;
        if (this.packets.has(currentPacketId)) {
            emcPacket = EmcPacketCollection.getPacket(this.systemId, currentPacketId);
            this.pollAttempt = 1;
            packetFound = true;
        }
        else {
            if (this.pollAttempt >= EmcConsts.MAX_POLL_LIMIT) {
                this.lastPacketId++;
                this.pollAttempt = 1;
            }
            else
                this.pollAttempt++;
        }
        if (true == packetFound) {
            this.lastPacketId++;
            this.removePacket(currentPacketId);
        }
        ConsoleLogger.log("Current packet for systemId: " + this.systemId + " is " + currentPacketId + " with packet found: " + packetFound);
        return emcPacket;
    }
    isLagPresent() {
        return this.packets.has(this.lastPacketId + EmcConsts.MAX_LAG_PACKETS_COUNT);
    }
}
//# sourceMappingURL=EmcSystem.js.map